import { OrdenServicio } from "./ordenServicio";
import { Aseguradora } from "./aseguradora";
import { Cliente } from "./cliente";
import { Valuacion } from "./valuacion";
import { Cotizacion } from "./cotizacion";
import { Presupuesto } from "./presupuesto";
import { AutorizacionSeguro } from "./autorizacionSeguro";
import { Reparacion } from "./reparacion";
import { UnidadTerminada } from "./unidadTerminada";
import { EntregaUnidad } from "./entregaUnidad";

export class DashboardOS {
    claveOS: string;
    ordenServicio: OrdenServicio;
    aseguradora: Aseguradora;
    cliente: Cliente;
    valuacion: Valuacion;
    cotizacion: Cotizacion;
    presupuesto: Presupuesto;
    autorizacion: AutorizacionSeguro;
    reparacion: Reparacion;
    terminada: UnidadTerminada;
    entrega: EntregaUnidad;
    diasVencido: number;
    proceso: string;
    perdidaTotal: boolean;
    statusOS: string;
}

export class StatusTotal {
    status: string;
    total: number;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/dashboardos.ts